import {
	FETCH_PHARMACY_PROFILE_REQUEST,
	FETCH_PHARMACY_PROFILE_SUCCESS,
	FETCH_PHARMACY_PROFILE_FAILURE,
} from '../../constants';

const initialState = {
	profileData: null,
	loading: false,
	error: null,
	filemangerurl: null,
	accountabilitySettings: null,
	showAfterProcessPrepCheck: false
}

const userProfileReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_PHARMACY_PROFILE_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				profileData: null
			};
		case FETCH_PHARMACY_PROFILE_SUCCESS:
			return {
				...state,
				profileData: action.payload,
				loading: false,
				error: null,
			};
		case FETCH_PHARMACY_PROFILE_FAILURE:
			return {
				...state,
				profileData: null,
				loading: false,
				error: action.payload,
			};

		case 'GET_PHARMACY_FILE_MANAGER_URL_SUCCESS':
			return {
				...state,
				filemangerurl: action.payload,
				profileData: state.profileData,
			};

		case 'GET_PHARMACY_ACCOUNTABILITY_SETTINGS':
			return {
				...state,
				accountabilitySettings: action.payload,
				profileData: state.profileData,
			};

		case 'GET_AFTER_PROCESS_PREP_CHECK_SETTING':
			return {
				...state,
				showAfterProcessPrepCheck: action.payload === true,
				profileData: state.profileData,
			};
		default:
			return state;
	}
};

export default userProfileReducer;
